import React from "react";
import { ShieldCheck, CalendarClock, HandCoins } from "lucide-react";
import { benefits } from "../data/mock";

const iconMap = { ShieldCheck, CalendarClock, HandCoins };

export default function Benefits() {
  return (
    <section className="relative -mt-12 px-5 md:px-10">
      <div className="mx-auto max-w-[1180px]">
        <div className="grid gap-px overflow-hidden rounded-2xl border border-[#e2dccb] bg-white elev-card md:grid-cols-3">
          {benefits.map((b) => {
            const Icon = iconMap[b.icon];
            return (
              <div key={b.title} className="relative bg-white p-7 md:p-9">
                <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-[#ece6d4]">
                  <Icon className="h-5 w-5 text-[#9c8345]" strokeWidth={2.4} />
                </div>
                <h3 className="font-serif-display mt-5 text-[24px] text-[#0e1a2b]">
                  {b.title}
                </h3>
                <p className="mt-2 text-[13.5px] leading-relaxed text-[#54657a]">
                  {b.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
